import { LoaderFunction } from 'react-router-typesafe'
import { RoleRouteObject } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import ClientGroupsPage from '@/routes/clients/client-groups/ClientGroupsPage'
import { faPeopleGroup } from '@fortawesome/free-solid-svg-icons'
import { getAzureUserInformation } from '@/auth/azure/azureManager'

export const clientGroupsPageRouteLoader = (async () => {
  const title = 'Gruppi aziendali'
  return {
    title,
    userInfo: await getAzureUserInformation(),
    defaultCRUDAllowedRoles: [Roles.GlobalAdministrator, Roles.Administrator, Roles.Supervisor],
  }
}) satisfies LoaderFunction

export const ClientGroupsPageRoute = {
  path: 'groups',
  loader: clientGroupsPageRouteLoader,
  element: <ClientGroupsPage />,
  handle: {
    crumb: () => ({
      label: 'Gruppi aziendali',
      icon: faPeopleGroup,
    }),
  },
  allowedRoles: [
    Roles.GlobalAdministrator,
    Roles.Administrator,
    Roles.Supervisor,
    Roles.Marketing,
    Roles.Sales,
    Roles.TechDeveloper,
  ],
} satisfies RoleRouteObject
